/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Exit_Scanning_WarningInputs */

const en_mobile_exit_scanning_warning = /** @type {(inputs: Mobile_Exit_Scanning_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to exit scanning? All scanned pages will be lost.`)
};

const es_mobile_exit_scanning_warning = /** @type {(inputs: Mobile_Exit_Scanning_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Seguro que quieres salir del escaneo? Se perderán todas las páginas escaneadas.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to exit scanning? All scanned pages will be lost." |
*
* @param {Mobile_Exit_Scanning_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_exit_scanning_warning = /** @type {((inputs?: Mobile_Exit_Scanning_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Exit_Scanning_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_exit_scanning_warning(inputs)
	return en_mobile_exit_scanning_warning(inputs)
});